var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTagInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C3D2DF",
    fillRule: "evenodd",
    d: "M14.42 4.518a.94.94 0 1 0-1.878 0 .94.94 0 0 0 1.878 0zm-6.567 10.94l8.131-8.132a.469.469 0 0 0 .137-.332V2.817c0-.52-.42-.94-.939-.94h-4.177a.47.47 0 0 0-.332.138l-8.132 8.132a.94.94 0 0 0 0 1.328l3.984 3.984a.94.94 0 0 0 1.328 0zM3.66 6.374L9.758.274A.941.941 0 0 1 10.42 0h5.7C17.16 0 18 .84 18 1.877v5.701c0 .249-.1.487-.275.664L8.516 17.45a1.877 1.877 0 0 1-2.655 0L.55 12.138a1.878 1.878 0 0 1 0-2.655l3.11-3.11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTagInactive);
export default __webpack_public_path__ + "static/media/icon_tag_inactive.21e2869cc3053f308b57c395d7e81ed3.svg";
export { ForwardRef as ReactComponent };